// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
// import {Link} from "react-router-dom";
import {Col, Row, Table} from "antd";
import * as Setting from "../../conf/Setting";
import * as SyncerBackend from "../../services/SyncerBackend";
import i18next from "i18next";
import BaseListPage from "../../components/basic/BaseListPage";
import {ArrowLeftOutlined} from "@ant-design/icons";

class UpstreamSyncerLogDetailPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
    };
  }

  UNSAFE_componentWillMount() {
    this.state.pagination.pageSize = 20;
    const {pagination} = this.state;
    this.fetch({pagination});
  }

  renderTable(records) {
    let columns = [
      {
        title: i18next.t("general:Number"),
        dataIndex: "index",
        key: "index",
        width: (Setting.isMobile()) ? "60px" : "100px",
        fixed: "left",
        align: "center",
        render: (text, record, index) => `${index + 1}`,
      },
      {
        title: this.props.detail.syncType === 1 ? i18next.t("syncer:Department code") : i18next.t("syncer:Username"),
        dataIndex: "objectId",
        key: "objectId",
        width: "150px",
      },
      {
        title: i18next.t("syncer:Event type"),
        dataIndex: "syncType",
        key: "syncType",
        width: "120px",
        filterMultiple: false,
        filters: [
          {text: i18next.t("syncer:Create"), value: "创建"},
          {text: i18next.t("syncer:Update"), value: "更新"},
          {text: i18next.t("syncer:Delete"), value: "删除"},
        ],
        render: (text, record, index) => {
          return `${record.syncType}${record.objectType}`;
        },
      },
      {
        title: i18next.t("syncer:Sync time"),
        dataIndex: "createdTime",
        key: "createdTime",
        width: "200px",
        sorter: true,
      },
      {
        title: i18next.t("syncer:Sync state"),
        dataIndex: "status",
        key: "status",
        width: "110px",
        filterMultiple: false,
        filters: [
          {text: i18next.t("syncer:Success"), value: "1"},
          {text: i18next.t("syncer:Fail"), value: "0"},
        ],
        render: (text, record, index) => {
          if (text) {
            return i18next.t("syncer:Success");
          }
          return i18next.t("syncer:Fail");
        },
      },
    ];

    if (this.props.detail.syncType === 2) {
      columns = columns.filter(column => column.key !== "syncType");
    }

    const paginationProps = {
      total: this.state.pagination.total,
      pageSize: this.state.pagination.pageSize,
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: () => i18next.t("general:{total} in total").replace("{total}", this.state.pagination.total),
    };

    return (
      <div>
        <Row type="flex" style={{margin: "5px 0 10px 0"}}>
          <Col style={{fontSize: 16, marginRight: 30}}>
            <ArrowLeftOutlined style={{marginRight: 12}} onClick={() => this.props.dismiss()} />{i18next.t("syncer:Log detail")}
            <span style={{fontSize: 12, color: "rgba(0, 0, 0, 0.6)"}}>{i18next.t("syncer:Reserve data only within 180 days")}</span>
          </Col>
          <Col style={{fontSize: 16, marginRight: 30}}>{Setting.getLabel(i18next.t("syncer:Created quantity"), `${i18next.t("syncer:Succesful quantity")}/${i18next.t("syncer:Total")}`)}：{this.props.detail.createInfo}</Col>
          <Col style={{fontSize: 16, marginRight: 30}}>{Setting.getLabel(i18next.t("syncer:Updated quantity"), `${i18next.t("syncer:Succesful quantity")}/${i18next.t("syncer:Total")}`)}：{this.props.detail.updateInfo}</Col>
          <Col style={{fontSize: 16}}>{Setting.getLabel(i18next.t("syncer:Deleted quantity"), `${i18next.t("syncer:Succesful quantity")}/${i18next.t("syncer:Total")}`)}：{this.props.detail.deleteInfo}</Col>
        </Row>
        <Table scroll={{x: "max-content"}} columns={columns} dataSource={records} rowKey="id" size="middle" bordered pagination={paginationProps}
          loading={this.state.loading}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }

  fetch = (params = {}) => {
    let field = params.searchedColumn, value = params.searchText;
    const sortField = params.sortField, sortOrder = params.sortOrder;
    if (params.syncType !== undefined && params.syncType !== null) {
      field = "sync_type";
      value = params.syncType;
    } else if (params.status !== undefined && params.status !== null) {
      field = "status";
      value = params.status;
    }

    this.setState({loading: true});
    SyncerBackend.getUpstreamSyncerLogDetail(this.props.syncId, this.props.detail.uid, params.pagination.current, params.pagination.pageSize, field, value, sortField, sortOrder)
      .then((res) => {
        if (res.status === "ok") {
          this.setState({
            loading: false,
            data: res.data,
            pagination: {
              ...params.pagination,
              total: res.data2,
            },
            searchText: params.searchText,
            searchedColumn: params.searchedColumn,
          });
        }
      });
  };
}

export default UpstreamSyncerLogDetailPage;
